import { Component, Inject, OnInit } from '@angular/core';
import { ManagedClinicService } from '../managed-clinic.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClinicRoom } from '../managed-clinic.model';

@Component({
  selector: 'app-delete-room',
  templateUrl: './delete-room.component.html',
  styleUrls: ['./delete-room.component.scss'],
})
export class DeleteRoomComponent implements OnInit {
  roomArray: Array<ClinicRoomSelection> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { clinic_id: string; list: ClinicRoom[] },
    private managedClinicServices: ManagedClinicService,
    private dialogRef: MatDialogRef<DeleteRoomComponent>
  ) {}

  ngOnInit(): void {
    this.roomArray = this.data?.list;
  }

  deleteRoom() {
    const selectedList: string[] = [];
    this.roomArray.map((room) => {
      if (room?.is_selected) selectedList.push(room?.id);
    });
    this.managedClinicServices
      .deleteRoom(this.data?.clinic_id, selectedList)
      .subscribe({
        next: (res) => (res?.status ? this.dialogRef.close(true) : ''),
      });
  }
  close() {
    this.dialogRef.close(false);
  }
}

interface ClinicRoomSelection extends ClinicRoom {
  is_selected?: boolean;
}
